// Cartão de um ingresso (QR grande + infos do PDF). Usado pela página
// individual (/ingresso/:ticketNumber) e pela página do pedido (/pedido/:paymentId).
import React from 'react';
import { QRCodeSVG } from 'qrcode.react';

export interface IngressoResumo {
  ticket_number: number;
  nome: string;
  documento: string;
  tipo_ingresso: string;
  documento_meia_entrada?: string | null;
}

export interface EventoResumo {
  titulo: string;
  data: string;
  abertura: string;
  inicio: string;
  endereco: string;
  classificacao: string;
}

const IngressoCard: React.FC<{ ingresso: IngressoResumo; evento: EventoResumo }> = ({
  ingresso,
  evento,
}) => {
  const qrUrl = `https://espacoera.store/validate/${ingresso.ticket_number}`;
  const isMeia = String(ingresso.tipo_ingresso).trim().toLowerCase() === 'meia';

  return (
    <article className="era-ingresso-card" aria-label={`Ingresso ${ingresso.ticket_number}`}>
      <p className="era-ingresso-evento">{evento.titulo}</p>
      <p className="era-ingresso-data">
        {evento.data} · Abertura {evento.abertura} · Início {evento.inicio}
      </p>

      <h2 className="era-ingresso-numero">Nº {ingresso.ticket_number}</h2>
      <p className={`era-ingresso-selo ${isMeia ? 'meia' : 'inteira'}`}>
        {isMeia ? 'MEIA' : 'INTEIRA'}
      </p>

      <div className="era-ingresso-qr">
        <QRCodeSVG
          value={qrUrl}
          size={264}
          level="H"
          includeMargin
          aria-label={`QR do ingresso ${ingresso.ticket_number}`}
        />
      </div>
      <p className="era-ingresso-qr-legenda">APRESENTE ESTE QR NA ENTRADA</p>
      <p className="era-ingresso-qr-url">{qrUrl.replace('https://', '')}</p>

      <dl className="era-ingresso-dados">
        <div>
          <dt>Participante</dt>
          <dd>{ingresso.nome}</dd>
        </div>
        <div>
          <dt>Documento</dt>
          <dd>{ingresso.documento}</dd>
        </div>
        {isMeia && (
          <div>
            <dt>Comprovante meia-entrada</dt>
            <dd>{ingresso.documento_meia_entrada || '—'}</dd>
          </div>
        )}
        <div>
          <dt>Local</dt>
          <dd>{evento.endereco}</dd>
        </div>
        <div>
          <dt>Classificação</dt>
          <dd>{evento.classificacao}</dd>
        </div>
      </dl>

      <p className="era-ingresso-aviso">
        Vale exibir na tela do celular ou imprimir. Chegue com 30 minutos de
        antecedência e traga documento com foto.
      </p>
    </article>
  );
};

export default IngressoCard;
